import { defineStore } from "pinia"
import type { DataTableFilterMeta, DataTableSortEvent } from "primevue/datatable"

import { type Table } from "@/graphql/types"

import type { GenericObject } from "vee-validate"

type TableStateMap = Map<Key, States>
type Key = Table | string
type States = {
  filterPresetFormValues?: GenericObject
  displayFilterForm?: boolean
  defaultFilters?: DataTableFilterMeta
  tableFilters?: DataTableFilterMeta
  columnPresetKeys?: Set<string>
  filterPresetKeys?: Set<string>
  dataTableState?: Pick<DataTableSortEvent, "first" | "rows" | "sortField" | "sortOrder">
}

const useTableStateStore = defineStore("tableStateStore", () => {
  const cache: TableStateMap = new Map()

  function set(key: Key, state: States) {
    if (!cache.has(key)) {
      cache.set(key, state)
    } else {
      cache.set(key, { ...cache.get(key), ...state })
    }
  }

  function get(key: Key) {
    return cache.get(key)
  }

  return {
    set,
    get,
  }
})

export default useTableStateStore
